import { Box, Link, Text } from '@chakra-ui/react'
import { Banner } from '@opengovsg/design-system-react'

import { HACK_FOR_PUBLIC_GOOD_URL } from '~constants/config'

export const HackathonBanner = () => {
  // NOTE: There is something wrong with the design system banner that it gets flex shrunk on mobile view.
  return (
    <Box flexShrink={0}>
      <Banner size="sm" isDismissable={false} variant={'info'}>
        <Text textStyle="body-2">
          This is an exploratory prototype that was built as part of OGP’s{' '}
          <Link
            color="white"
            _hover={{
              color: 'interaction.links.inverse-hover',
              textDecorationLine: 'underline',
            }}
            variant="inline"
            textDecorationLine="none"
            href={HACK_FOR_PUBLIC_GOOD_URL}
            isExternal
          >
            Hack for Public Good
          </Link>
        </Text>
      </Banner>
    </Box>
  )
}
